import { validateSweep } from './previewRule';

export function validateSettings(settings) {
  const errors = validateSweep(settings.sweep);
  if (!settings.storesInScope?.length)
    errors.push(
      'Choose at least one store. Leaving this empty would include every store.'
    );
  Object.entries({
    done: 'Done',
    manual: 'Manual-override',
    needsDims: 'Needs-dimensions',
    error: 'Error'
  }).forEach(([key, label]) => {
    if (!String(settings.tags?.[key] || '').trim())
      errors.push(`The ${label} tag name is required.`);
  });
  const max = Number(settings.sweep?.maxShipmentsPerRun);
  if (max > 0 && (!Number.isInteger(max) || max > 1000))
    errors.push('Max shipments per run must be an integer between 1 and 1000.');
  return errors;
}

export const settingsPatch = draft => ({
  enabled: draft.enabled,
  dryRun: draft.enabled ? draft.dryRun : true,
  storesInScope: draft.storesInScope,
  groups: { ...draft.groups },
  comparableServices: draft.comparableServices,
  carrierAccounts: { ...(draft.carrierAccounts || {}) },
  tags: Object.fromEntries(
    ['done', 'manual', 'needsDims', 'error'].map(key => [
      key,
      String(draft.tags[key] || '').trim()
    ])
  ),
  sweep: {
    ...draft.sweep,
    lookbackHours: Number(draft.sweep.lookbackHours),
    maxShipmentsPerRun: Number(draft.sweep.maxShipmentsPerRun)
  },
  respectHumanOverride: draft.respectHumanOverride
});

/** Selection order is not a settings change. Keep writes in their existing shape. */
export const settingsSignature = settings =>
  JSON.stringify({
    ...settingsPatch(settings),
    storesInScope: [...(settings.storesInScope || [])].sort(),
    comparableServices: [...(settings.comparableServices || [])].sort()
  });
